import {
  createBaseAsyncHandlers,
  createStartAction,
  createSuccessAction,
  initialState,
  makeDataUpdater,
} from '../../../redux-util/async-helpers';
import {
  GET_HIGHLIGHTS,
  DELETE_HIGHLIGHT,
  UPDATE_HIGHLIGHT,
  HIGHLIGHT_CURRENT,
} from '../../jigsaw-methods';
import { createReducer } from '../../../redux-util/general-helpers';
import { removeFromArray } from '../../../../utils/array';
import { withDestroyViewerReset } from '../../../reset-reducer-helpers';

// Needs to be delete start to stay consistent with highlight removal on the page
const deleteStart = createStartAction(DELETE_HIGHLIGHT).type;
const updateSuccess = createSuccessAction(UPDATE_HIGHLIGHT).type;
const highlightCurrentSuccess = createSuccessAction(HIGHLIGHT_CURRENT).type;

function doDelete(state, action) {
  const highlights = removeFromArray(
    state.highlights,
    'syncId',
    action.data[0]
  );
  return {
    ...state,
    highlights,
  };
}

function doUpdate(state, action) {
  const newHighlight = action.data.highlight;
  return {
    ...state,
    highlights: state.highlights.map(h =>
      h.syncId === newHighlight.syncId ? newHighlight : h
    ),
  };
}

function handleSuccess(state, action) {
  return {
    ...state,
    highlights: [...state.highlights, action.data.highlight],
  };
}

const base = createBaseAsyncHandlers(GET_HIGHLIGHTS);
const extras = {
  [deleteStart]: makeDataUpdater(doDelete),
  [updateSuccess]: makeDataUpdater(doUpdate),
  [highlightCurrentSuccess]: makeDataUpdater(handleSuccess),
};

export default withDestroyViewerReset(
  createReducer(initialState, base, extras)
);
